import Dexie, { type EntityTable } from "dexie";
import type { AssetFileRecord, AssetRecord, PhotoFolioProject } from "../domain/project";

class PhotoFolioDatabase extends Dexie {
  projects!: EntityTable<PhotoFolioProject, "id">;
  assets!: EntityTable<AssetRecord, "id">;
  assetFiles!: EntityTable<AssetFileRecord, "id">;

  constructor() {
    super("photofolio");
    this.version(1).stores({
      projects: "id, updatedAt, lastOpenedAt",
      assets: "id, projectId, createdAt",
      assetFiles: "id, [projectId+assetId+variant], projectId, assetId",
    });
  }
}

export const db = new PhotoFolioDatabase();

export const listProjects = () => db.projects.orderBy("lastOpenedAt").reverse().toArray();

export async function saveProject(project: PhotoFolioProject) {
  await db.projects.put(project);
}

export async function removeProject(projectId: string) {
  const fileRows = await db.assetFiles.where("projectId").equals(projectId).toArray();
  await db.transaction("rw", db.projects, db.assets, db.assetFiles, async () => {
    await db.projects.delete(projectId);
    await db.assets.where("projectId").equals(projectId).delete();
    await db.assetFiles.bulkDelete(fileRows.map((row) => row.id));
  });
}
